// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';
import { dispatch } from '../index';

// ----------------------------------------------------------------------

const initialState = {
    error: null,
    notifications: []
};

const slice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },

        // GET ADMINS
        getNotificationsSuccess(state, action) {
            state.notifications = action.payload.notificationList;
        }
    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getNotifications(data) {
    return async () => {
        try {
            const response = await axios.post('/api/notification/list', data,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            }
            );
            dispatch(slice.actions.getNotificationsSuccess(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function markAsRead(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/notification/markAsRead', data,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            }
            );
            if(callback){
                callback(response);
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}
